<template>
  <default-layout>
    <v-container>
      <v-row>
        <v-col class="mt-12">
          <h1>Business Account Selection</h1>
        </v-col>
      </v-row>
      <v-row v-if="hasBusinesses">
        <v-col>
          <BusinessAccountSelectionList :businesses="businesses" />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <h2>No Business accounts assosiated with this profile</h2>
        </v-col>
      </v-row>
      <!--<v-row>
        <v-col md="12">
          {{ token }} 
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" class="mt-10">
          {{ businesses }}
        </v-col>
      </v-row>-->
    </v-container>
  </default-layout>
</template>
<script>
import facebookApi from "@/api/facebook.js";
import DefaultLayout from "@/layouts/Default";
import BusinessAccountSelectionList from "@/components/BusinessAccountSelectionList";

export default {
  name: "BusinessAccountSelection",
  components: {
    DefaultLayout,
    BusinessAccountSelectionList
  },
  data() {
    return {
      //businesses: {},
      loading: false,
      businesses: {
        data: [
          {
            access_token:
              "EAAEqH4g3cOgBAMVpv47ycehnnh0YsufZBbO7jD3XYYOkKDZClPZBTHoHzBPqO6RtUeWmgxtPq5JnAh7CnsOhcxq6zLlioPGx9LsBPrPvIgi8JHzVcc8fTV1vOWPB9vsPCSdDYWyqS2B7wXsvadHUFF0TopZBgLb1qvvjxCPvDfNdFhZCyyZCHZCB3Vle11lFoKQFRjvLPCMdQZDZD",
            category: "Est\u00e1dio, gin\u00e1sio e complexo esportivo",
            category_list: [
              {
                id: "109976259083543",
                name:
                  "Est\u00e1dio, gin\u00e1sio e instala\u00e7\u00e3o esportiva"
              }
            ],
            name: "Arena Fotos",
            id: "139048036282125",
            tasks: [
              "ANALYZE",
              "ADVERTISE",
              "MODERATE",
              "CREATE_CONTENT",
              "MANAGE"
            ]
          },
          {
            access_token:
              "EAAEqH4g3cOgBAA2oJSmdLkJ3JjPkUGsfjsYrvEQJx1iTJZBoTmZB47EvuWZCZCaI8ulTQ2haZA9ZCa5cNRfZCUhQWnXo0mUF1NsXZB8uaNwguZC2mX54HQ51IKZCRR5hErrG723k10sQqKDnvnREDy3kScpeA1pLMTdEZCbu4Jc4uqKGudhzQqTIZAWXq4WQ2XmA460UVoxgUQEFAwZDZD",
            category: "Empresa de tecnologia da informa\u00e7\u00e3o",
            category_list: [
              {
                id: "1130035050388269",
                name: "Empresa de tecnologia da informa\u00e7\u00e3o"
              }
            ],
            name: "Pelican Analytics",
            id: "306876970028966",
            tasks: [
              "ANALYZE",
              "ADVERTISE",
              "MODERATE",
              "CREATE_CONTENT",
              "MANAGE"
            ]
          },
          {
            access_token:
              "EAAEqH4g3cOgBALZB1tOijcGvXCNXr7DtxnILwBmWSfcfZC4S85C19W8wOy3cnoO9GZCHw5mMqIenKfGoYukUZCQ94uEJvPpZBZCHQE6qQrFJWEuliAoxl7V4YHFGpQTujOdtXZATzuyQ8sZBfig4evL0YCuUWwB29O8ULlcpYcoAw5ZB10PtrI3zzcdwSf6r9ivs7wHgGMNdFggZDZD",
            category: "Blog pessoal",
            category_list: [{ id: "2700", name: "Blog pessoal" }],
            name: "Tripper Happy",
            id: "400713370722747",
            tasks: [
              "ANALYZE",
              "ADVERTISE",
              "MODERATE",
              "CREATE_CONTENT",
              "MANAGE"
            ]
          },
          {
            access_token:
              "EAAEqH4g3cOgBAOWZBWvhN9XVxxXnqmuXfWNcKSPmg6G4rOtGcg5jOdhBwTdP2ovV0gBmUZCFSrxbAoquIKFo5WIDxRXAffsIqNN58J4au4ozwjGmFZAdXI5rGnMbu1b60ZBemWQ73zz4Tu1ZBQXrXWfRIM37x6ogZCyifwmAdrYdEgyqV61Ji7bUefFwjTNC7y0towJNVZCGAZDZD",
            category: "Empresa de inform\u00e1tica",
            category_list: [
              { id: "2255", name: "Empresa de computadores" },
              { id: "2256", name: "Provedor de Internet" }
            ],
            name: "Lermann.com.br",
            id: "440828312758738",
            tasks: [
              "ANALYZE",
              "ADVERTISE",
              "MODERATE",
              "CREATE_CONTENT",
              "MANAGE"
            ]
          },
          {
            access_token:
              "EAAEqH4g3cOgBAIZCWPci0sHAKZCvcYvGodVPvZBmWZCEnZC42PZBwEtjH43U0XLZCfqZCpY5jQdLkNVLpDCD0FQaZAci5qmP5xLz2tNeXqUxKIYr18Kt9rRy0kk7fvO0bptwolrIXZC3sianQXjRxVjRAPmDJzhlrZBNy6poVrZAvAWeZAxs9dHKoi0QEZCUXxJZCxK2ZAZBqhb0JZBdI3WAZDZD",
            category: "Ag\u00eancia de viagens",
            category_list: [{ id: "2258", name: "Ag\u00eancia de viagens" }],
            name: "Melhores Passagens",
            id: "554895274614820",
            tasks: [
              "ANALYZE",
              "ADVERTISE",
              "MODERATE",
              "CREATE_CONTENT",
              "MANAGE"
            ]
          },
          {
            access_token:
              "EAAEqH4g3cOgBAN8CGD8EAV0IZAWTGWRn4UdaQwh8QctjG8IGAZCyuZAkfqDWZA0biVzdZACoTF3C5sAvv9wwMlQWMJ1b85dkD0SHnxrvI2BFp0QYFKWGVZAKxamsYIIZC4KXKcmfH2cITSdZBG9J4jkuX39axKfzQN8kil6CRDdGkKZC1pFf03sCEh19yAMInVWfH73Y8G5aPsAZDZD",
            category: "Site",
            category_list: [{ id: "2202", name: "Site" }],
            name: "Site do Advogado",
            id: "948612581896483",
            tasks: [
              "ANALYZE",
              "ADVERTISE",
              "MODERATE",
              "CREATE_CONTENT",
              "MANAGE"
            ]
          },
          {
            access_token:
              "EAAEqH4g3cOgBAPENbItPmR6bf2BQZBS7KjVFMcj03UdTu5TJqxn7lWZC0qq5l1yoDoGUv9FnOK4fuuEZBCdAbHCNl4jMW2QXafTedtRMk1oOZCiNL2aw84lHK0rQYA5AEwzZBXChRseOL2VaR3mVsk7SNbgCRY8ZBmjDZANbfwfHS3IK9wHBOt1OH8ZAhKXvHnqZAbDvPFs5FegZDZD",
            category: "Site de locais e viagem",
            category_list: [{ id: "2715", name: "Site de locais e viagem" }],
            name: "Viagens e Dicas",
            id: "1101532696581836",
            tasks: [
              "ANALYZE",
              "ADVERTISE",
              "MODERATE",
              "CREATE_CONTENT",
              "MANAGE"
            ]
          },
          {
            access_token:
              "EAAEqH4g3cOgBAE3kgC60XbkcPpCSUgCfXr7BYCj8E1toHLZBIx9rExzC8wlt189VPyuCd2K6h96xvDxTJKpunwXQx5PxVoqYuQTPc4DEZBJzex08cTY9bVOkxxxYUKkJPTFVz77y0CG4XoMrBZBoTaCXdcp7XDtJKp3bj6RZBXnlwZA13aShuZADdu2uKuoZC3IBrRT8Inm3wZDZD",
            category: "Promotor de eventos",
            category_list: [
              { id: "193705277324704", name: "Promotor de eventos" },
              {
                id: "189334414420898",
                name: "Servi\u00e7o de festas e entretenimento"
              }
            ],
            name: "Guia Fester\u00ea",
            id: "1244939295598944",
            tasks: [
              "ANALYZE",
              "ADVERTISE",
              "MODERATE",
              "CREATE_CONTENT",
              "MANAGE"
            ]
          },
          {
            access_token:
              "EAAEqH4g3cOgBAB87DZA06NzKlyXuDqBr3QDhv9KhbCr79fQJHL9ZAWimX1omnw6ShGAlLZBcZBFXr62d5AAk8Di5AvtDBOTo3EZCXuDtAZAr5PIu0ZAYv5G3noDWpE0gKZCYd6wV2O9p94OS7P2QS5nDCCMl1ZAKhOACOo5nM2X1QCM12S2tYCHwt1ZBWwRJni6trKYjqXWC956AZDZD",
            category: "Loja de roupas infantis",
            category_list: [
              { id: "192614304101075", name: "Loja de roupas infantis" },
              { id: "2239", name: "Empresa de varejo" }
            ],
            name: "Roupas de crian\u00e7a importadas dos EUA",
            id: "1736987906580091",
            tasks: [
              "ANALYZE",
              "ADVERTISE",
              "MODERATE",
              "CREATE_CONTENT",
              "MANAGE"
            ]
          }
        ],
        paging: {
          cursors: {
            before: "MTM5MDQ4MDM2MjgyMTI1",
            after: "MTczNjk4NzkwNjU4MDA5MQZDZD"
          }
        }
      }
    };
  },

  computed: {
    token() {
      return this.$store.getters.facebook;
    },
    hasBusinesses() {
      return this.businesses.data.length > 0 ? true : false;
    }
  },
  mounted() {
    //this.getBusinessAccounts();
  },
  methods: {
    getBusinessAccounts() {
      this.loading = true;
      facebookApi
        .getBusinesses(this.token.authResponse.accessToken)
        .then(resp => {
          this.loading = false;
          this.businesses = resp.data.data;
        });
    }
  }
};
</script>
